import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Chart_Image from "../assets/Analytics_Dashboard.png";
import { Button, Typography } from "antd";
import { Form, Input } from "antd";
import { useDispatch } from "react-redux";
import { loginUser } from "../Store/authSlice";
import { User, Lock, Eye, EyeOff, ArrowRight } from "lucide-react";
import logo from "../assets/IntelQuant_Logo.png";

// import { useMsal } from "@azure/msal-react";

function Login() {
  const [darkMode, setDarkMode] = useState(false);
  const { Title, Text } = Typography;
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showpassword, setShowpassword] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  // const { instance } = useMsal();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // useEffect(() => {
  //   const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  //   if (isAuthenticated) {
  //     navigate("/");
  //   }
  // }, []);

  //..18.06.2026..//
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

    if (token && isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  //   const handleSSOLogin = () => {
  // instance.loginRedirect({
  //   scopes: ["openid", "profile"],
  //   prompt: "select_account",
  //   redirectStartPage: "/auth/callback",
  // });
  //   };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "email is required";
    }

    if (!formData.password) {
      newErrors.password = "password is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      await dispatch(loginUser(formData)).unwrap();

      navigate("/", {
        replace: true,
      });
    } catch (error) {
      console.error("Login Failed", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (values) => {
    try {
      await dispatch(loginUser(values)).unwrap();

      navigate("/", {
        replace: true,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* LEFT SIDE (IMAGE) */}
      <div
        className={`w-1/2 hidden md:flex items-center justify-center p-10 ${
          darkMode
            ? "bg-gray-900"
            : "bg-gradient-to-br from-blue-900 to-blue-600"
        }`}
      >
        <img
          src={Chart_Image}
          alt="Analytics"
          className="max-w-full h-auto rounded-xl shadow-2xl"
        />
      </div>

      {/* RIGHT SIDE (SSO LOGIN) */}
      <div className="w-full md:w-1/2 flex items-center justify-center bg-white relative px-6">
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage:
                "radial-gradient(circle at 1px 1px, #3b82f6 1px, transparent 0)",
              backgroundSize: "20px 20px",
            }}
          />
        </div>

        <div className="w-full max-w-md mx-auto relative z-10">
          <div className="bg-white rounded-3xl shadow-2xl p-8 border border-gray-100">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-4">
                <img
                  src={logo}
                  alt="logo"
                  className="w-20 h-20 object-contain"
                />
              </div>

              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                Welcome to KeibiAI
              </h1>

              <p className="text-gray-600">Login with your credentials</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* email */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email
                </label>

                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <User className="h-5 w-5 text-gray-400" />
                  </div>

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter your email"
                    disabled={isLoading}
                    className={`w-full pl-12 pr-4 py-4 border-2 rounded-xl focus:ring-4 focus:ring-blue-500 focus:ring-opacity-20 focus:border-blue-500 transition-all duration-200 bg-gray-50 hover:bg-white ${
                      errors.email
                        ? "border-red-500 bg-red-50"
                        : "border-gray-200"
                    }`}
                  />
                </div>

                {errors.email && (
                  <p className="mt-2 text-sm text-red-600">{errors.email}</p>
                )}
              </div>

              {/* password */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Password
                </label>

                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <Lock className="h-5 w-5 text-gray-400" />
                  </div>

                  <input
                    type={showpassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="••••••••"
                    disabled={isLoading}
                    className={`w-full pl-12 pr-12 py-4 border-2 rounded-xl focus:ring-4 focus:ring-blue-500 focus:ring-opacity-20 focus:border-blue-500 transition-all duration-200 bg-gray-50 hover:bg-white ${
                      errors.password
                        ? "border-red-500 bg-red-50"
                        : "border-gray-200"
                    }`}
                  />

                  <button
                    type="button"
                    onClick={() => setShowpassword(!showpassword)}
                    className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-600"
                  >
                    {showpassword ? (
                      <EyeOff className="h-5 w-5" />
                    ) : (
                      <Eye className="h-5 w-5" />
                    )}
                  </button>
                </div>

                {errors.password && (
                  <p className="mt-2 text-sm text-red-600">{errors.password}</p>
                )}
              </div>

              {/* Login Button */}
              <div className="space-y-3 pt-1">
                {/* Manual Login */}
                <button
                  type="submit"
                  disabled={isLoading}
                  className="w-full flex items-center justify-center px-4 py-2.5 text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm"
                >
                  {isLoading ? (
                    <div className="flex items-center">
                      <div className="animate-spin rounded-full h-4 w-4 border-2 border-white/80 border-t-transparent mr-2.5"></div>
                      Signing in...
                    </div>
                  ) : (
                    <span>Sign In</span>
                  )}
                </button>

                {/* Divider */}
                {/* <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-xs">
                    <span className="px-3 bg-white text-gray-400">or</span>
                  </div>
                </div> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
